import React from 'react';
import { pdf } from '@react-pdf/renderer';
import EventMainReport from '@/model/EventMainReport';
import { EventPdvSaleProductReport } from '@/model/EventPdvSaleProductReport';
import { ProductPdvPDF } from './ProductPdvPDF';

export const exportPdvPDF = async (
  event: EventMainReport,
  pdvs: EventPdvSaleProductReport[],
): Promise<void> => {
  try {
    const docElement = React.createElement(ProductPdvPDF, { event, pdvs });
    const instance = pdf(docElement as any);
    const blob = await instance.toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const sanitizedEventName = (event.name || 'evento').replace(/[^a-zA-Z0-9_-]/g, '_');
    link.download = `Relatorio_Produtos_PDV_${sanitizedEventName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Erro ao gerar PDF de PDVs:', error);
  }
};
